import React, { useState } from 'react'
import _ from 'lodash'
import {
  Paper, Fade, CircularProgress,
} from '@material-ui/core'
import {
  CompanyList, CompanyListItem, StyledPopper, CompanyInput,
} from '../styles'

const CompanyItem = (props) => {
  const { company, handleClick } = props
  return (
    <CompanyListItem
      data-testid="company-item"
      onClick={handleClick(company)}
    >
      {company.label}
    </CompanyListItem>
  )
}

const CompanySelect = (props) => {
  const {
    companyList, anchorEl, filterText, handleClick, loading, isAdmin,
  } = props

  const isOpen = Boolean(anchorEl)

  const children = companyList
    .filter((company) => company.label.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
    .map((company) => (<CompanyItem button key={company.value} {...{ company, handleClick }} />))

  const loadCompaniesList = () => {
    if (filterText === '' && isAdmin) {
      return (
        <CompanyListItem disabled data-testid="type-to-search-item" key="company-type-to-search-item">
          Type to search
        </CompanyListItem>
      )
    }
    if (loading) {
      return (
        <CompanyListItem disabled data-testid="loading-item" key="company-loading-item">
          <CircularProgress color="inherit" size={20} />
        </CompanyListItem>
      )
    }
    if (companyList.length === 0) {
      return (
        <CompanyListItem disabled data-testid="no-results-item" key="company-no-results-item">
          No Results
        </CompanyListItem>
      )
    }
    return (<CompanyList {...{ children }} data-testid="company-list" />)
  }

  return (
    <StyledPopper
      id={anchorEl ? 'company-select-list' : undefined}
      data-testid="company-select-list"
      placement="bottom-start"
      open={isOpen}
      anchorEl={anchorEl}
      transition
    >
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper>
            {loadCompaniesList()}
          </Paper>
        </Fade>
      )}
    </StyledPopper>
  )
}

export const AutoCompleteList = (props) => {
  const { companyList, selectedCompany, setSelectedCompany, isAdmin } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const [companies, setCompanies] = useState([])
  const [filterText, setFilterText] = useState('')
  const [loading, setLoading] = useState(false)

  const handleClick = (selectingCompany) => () => {
    setSelectedCompany(selectingCompany)
    setAnchorEl(null)
  }

  const search = (event) => {
    setAnchorEl(anchorEl || event.currentTarget)
    setFilterText(event.target.value)
    setLoading(true)
    setSelectedCompany({ label: '', value: '' })
    if (event.target.value.length >= 3 || !isAdmin) {
      _.delay(() => {
        const filteredCompanies = companyList.filter((company) => company.label.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
        setCompanies(filteredCompanies)
        setLoading(false)
      }, 1000)
    }
  }

  return (
    <div data-testid="select-company-autocomplete">
      <CompanySelect {...{
        companyList: companies, anchorEl, filterText, handleClick, loading, isAdmin,
      }}
      />
      <CompanyInput
        inputProps={{
          'data-testid': 'company-input-textbox',
        }}
        data-testid="company-input"
        aria-label="Company"
        name="company"
        autoComplete="off"
        value={selectedCompany && selectedCompany.label
          ? selectedCompany.label
          : filterText}
        placeholder="Search"
        onFocus={search}
        onBlur={() => {
          setAnchorEl(null)
          setLoading(false)
        }}
        onChange={search}
      />
    </div>
  )
}
